import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardHome from './pages/DashboardHome';
import Messages from './pages/Messages';
import FileSharing from './pages/FileSharing';
import StaffManagement from './pages/StaffManagement';
import PatientManagement from './pages/PatientManagement';
import M365Management from './pages/M365Management';

const isAdmin = () => localStorage.getItem('userRole') === 'admin';

const Dashboard = () => {
  return (
    <Routes>
      <Route path="" element={<DashboardHome />} />
      <Route path="messages" element={<Messages />} />
      <Route path="files" element={<FileSharing />} />
      <Route path="m365" element={isAdmin() ?<M365Management /> : <Navigate to="/dashboard" replace />} />
      <Route path="staff" element={isAdmin() ? <StaffManagement /> : <Navigate to="/dashboard" replace />} />
      <Route path="patients" element={<PatientManagement />} />
    </Routes>
  );
};

export default Dashboard; 